import { render, staticRenderFns } from "./yizhan_active.vue?vue&type=template&id=7c81e801&scoped=true&"
import script from "./yizhan_active.vue?vue&type=script&lang=js&"
export * from "./yizhan_active.vue?vue&type=script&lang=js&"
import style0 from "./yizhan_active.vue?vue&type=style&index=0&id=7c81e801&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c81e801",
  null
  
)

export default component.exports